import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import classnames from 'classnames';
import { TEXT_BUTTON_PRIORITY, TextButton } from 'wix-ui-tpa/TextButton';
import { Text } from 'wix-ui-tpa/Text';

import { ApiTypes, GroupAppsMap } from '@wix/social-groups-api/dist/src/types';
import { Box, Header } from '@wix/social-groups-common';
import { compose } from '@wix/social-groups-common/dist/src/compose';
import {
  withBiLogger,
  WithBiLoggerProps,
  tryToCallBi,
} from '@wix/social-groups-common/dist/src/context';
import { contentStringToText } from '@wix/social-groups-common/dist/src/components/ContentEditor/utils';
import { WithGroupActionProps, WithGroupActions } from '../../Context';

import styles from './About.st.css';
import discussionStyles from '../Discussion.st.css';

interface AboutComponentProps {
  group?: ApiTypes.v1.GroupResponse;
  apps: GroupAppsMap;
}

export interface AboutProps extends WithGroupActionProps, AboutComponentProps {}

export const AboutComponent: React.FC<AboutProps &
  InjectedTranslateProps &
  WithBiLoggerProps> = ({ t, group, changeTab, biLogger, apps }) => {
  const descr = contentStringToText(group.details.description);

  const onReadMore = () => {
    tryToCallBi(async () => {
      await biLogger.groupsTabClicked({
        group_id: group.groupId,
        origin: 'pinned_window',
        name: 'about',
      });
    });

    changeTab('about');
  };

  const readMore =
    descr && descr.length > 60 ? (
      <>
        ...
        <TextButton
          onClick={onReadMore}
          priority={TEXT_BUTTON_PRIORITY.primary}
          className={styles.readMore}
        >
          {t('groups-web.more')}
        </TextButton>
      </>
    ) : null;
  return (
    <Box article>
      <Header {...discussionStyles(discussionStyles.widgetHeader)}>
        {getAboutTabName() || t('groups-web.discussion.about.title')}
      </Header>
      <Text
        className={classnames(styles.description, discussionStyles.widgetText)}
      >
        {(descr && descr.substr(0, 60)) ||
          t('groups-web.discussion.about.description')}
        {readMore}
      </Text>
    </Box>
  );

  function getAboutTabName() {
    try {
      const { customName } = apps[ApiTypes.v1.GroupAppKey.ABOUT_APP] || null;
      return customName;
    } catch (e) {}
  }
};

const enhance = compose(translate(), WithGroupActions, withBiLogger);

export const About = enhance(AboutComponent) as React.ComponentType<
  AboutComponentProps
>;
